import { Component, OnInit } from '@angular/core';
import { ViewService } from '@services/view.service';
import { GlobalService } from '@common/global';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { CommonPipe } from '@pipes/common.pipe';
import { MailService } from '@services/mail.service';
import * as _ from 'lodash';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { fadeInLeftOnEnterAnimation } from 'angular-animations';
import { PollService } from '@services/poll.service';
@Component({
  selector: 'app-vpoll',
  templateUrl: './vpoll.component.html',
  styleUrls: ['./vpoll.component.sass'],
  animations: [
    fadeInLeftOnEnterAnimation({ anchor: 'fadeInLeft' })
  ]
})
export class VpollComponent implements OnInit {
  application = "poll";
  component = '';
  compose_response: any = [];
  is_owner=false;
  rate = 0;
  comments_count=0;
  params: any = [];
  action_class:any={};
  id = "";
  response: any = [];
  images: any = [];
  report_param: any = [];
  isLogin = false;
  btn_process = false;
  rate_readonly = false;
  page_load=true;
  questions: any = [];
  answers: any = {};
  question_no = 0;
  total_question = 0;
  btn_show: any = {};
  questionids:any=[];
  pollJson:any=[];
  pollId='';
  ans=[];
  sidetabs={"recent":"Recent","viewed":"Views","rated":"Popular","liked":"Liked","favorites":"Favorite"};
  constructor(private _pollervice: PollService,public ngxSmartModalService: NgxSmartModalService, private _mail: MailService,  private router: Router, private _commonPipe: CommonPipe,  private route: ActivatedRoute, private _viewService: ViewService, private _global: GlobalService) {

    
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    }
    if (this._global.isAuthenticated()) {
      this.isLogin = true;
    }

    let pa=this._global.getAppViewParam(this.route.snapshot.url[1].path);
    this.component=pa.c;
    this.id=pa.id;
    this.pollId=this.id;
      let p = {
        'component': this.component,
        'application': this.application,
        'id': this.id
      };
      this._viewService.application(p).subscribe(
        data => {
          if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
            this.page_load=false;
            this.response = this._global.getVal(data, 'response', {});
            this.pollJson=this.response['pollJson'];
            this.questions=this.response['pollJson']['questions'];
            this.total_question = this._global.getVal(this.pollJson,'numQuestions',0);
            if (this.total_question == 1) {
              this.btn_show['submit'] = true;
            } else if (this.total_question > 1) {
              this.btn_show['next'] = true;
            }
            this.is_owner=this._global.isOwner(this._global.getVal(this.response, 'createdBy', ''));
           
            this._global.addMetaInfo(this.response, 'view','name');
            this.report_param = {
              id: this.response.id,
              name: this.response.name
            };
           
          }else{
            this.router.navigate(['']);
          }

        },
        error => {
          console.log("error", JSON.stringify(error));
          this.router.navigate(['']);
        });
  }
  ngOnInit() {

  }
  
 
  edit(){
    this.router.navigate(['/edit/'+this.application], { queryParams: { 'id' : this.id } });
  }


  report() {

    this.ngxSmartModalService.getModal('popupOne').open()
    let p = {
      component: 'm',
      application: 'mail'
    };
    this._mail.compose(p).subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.compose_response = this._global.getVal(data, 'response', '');
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
  }
  commentCount(e){
    console.log("eeeee",e)
  }
  nextQuestion() {

    console.log(this.question_no,this.questionids[this.question_no])
    this.pollVote(this.questionids[this.question_no],this.ans[this.question_no])
    this.btn_show['submit'] = false;
    if (this.total_question > (this.question_no + 1)) {
      this.question_no += 1;
      this.btn_show['prev'] = true;
    } else {
      this.btn_show['prev'] = false;
      this.btn_show['next'] = false;
    }
    if (this.total_question == this.question_no + 1) {
      this.btn_show['submit'] = true;
      this.btn_show['next'] = false;
    }

    console.log("snabvdvsabdv",this.ans)
  }
  previousQuestion() {
    this.btn_show['submit'] = false;
    if (this.question_no > 0) {
      this.question_no -= 1;
      this.btn_show['next'] = true;
    } else {
      this.btn_show['prev'] = false;
      this.btn_show['next'] = true;
    }
    if (this.question_no == 0) {
      this.btn_show['prev'] = false;
    }
  }

  send() {
    console.log(this.question_no,this.questionids[this.question_no])
    this.pollVote(this.questionids[this.question_no],this.ans[this.question_no])
   /*  let final ={};
    Object.entries(this.questions).forEach(([key, value]) => {
      final[key] = {
        title: value['title']
      }
      let ans = [];
      Object.entries(value['a']).forEach(([key, value]) => {
        if (value['isChecked']) {
          ans.push(value['value'])
        }
      });
      final[key]['value'] = ans.join(",");

    });
    console.log("final", final)
    this.answers = final;
    console.log("dfdsnfnds",JSON.stringify(this.answers)) */
  }
  result(){
    /* let p={
      component:this.component,
      application:this.application,
      id:this.pollId
    };
    this._pollervice.result(p).subscribe(
      vote => {
        
        
      },
      error => {
        console.log("error", JSON.stringify(error));
      }); */
  }

  pollVote(qid,aid){
    if(qid && aid){
    let p={
      component:this.component,
      application:this.application,
      pollId:this.pollId,
      questionId:qid,
      answerId:aid
    };
    this._pollervice.vote(p).subscribe(
      vote => {
        
        
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
    }
  }

}